<template>
  <div class="password-edit-form">
    <form novalidate class="md-layout" @submit.prevent="validate">
      <md-card class="no-shadow md-layout-item md-size-100">
        <md-card-header>
          <div class="md-title">Update your password</div>
        </md-card-header>

        <md-card-content>
          <md-field :class="getValidationClass('oldPassword')">
            <label for="oldPassword">Current Password</label>
            <md-input type="password" name="oldPassword" id="oldPassword" autocomplete="off" v-model="form.oldPassword" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.password.required">The current password is required</span>
          </md-field>

          <md-field :class="getValidationClass('password')">
            <label for="password">Password</label>
            <md-input type="password" name="password" id="password" autocomplete="off" v-model="form.password" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.password.required">The password is required</span>
            <span class="md-error" v-else-if="!$v.form.password.minLength">The passwort must be at least 8 characters long.</span>
          </md-field>

          <md-field :class="getValidationClass('repeatPassword')">
            <label for="repeatPassword">Password Confirmation</label>
            <md-input type="password" name="repeatPassword" id="repeatPassword" autocomplete="off" v-model="form.repeatPassword" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.repeatPassword.required">The password is required</span>
            <span class="md-error" v-else-if="!$v.form.repeatPassword.sameAs">The passwords do not match</span>
          </md-field>

          <error-container :error="error"/>

        </md-card-content>

        <md-card-actions md-alignment="right">
          <md-button type="submit" class="md-raised md-primary" :disabled="sending">
            <span v-show="!sending">
              Update Password
            </span>
            <span v-show="sending">
              <md-progress-spinner
                :md-diameter="22"
                :md-stroke="2"
                md-mode="indeterminate"
              />
            </span>
          </md-button>
        </md-card-actions>
      </md-card>

      <md-snackbar :md-active.sync="passwordUpdated">Your password was succesfully changed.</md-snackbar>
    </form>
  </div>
</template>

<script>
import ErrorContainer from '../ErrorContainer'
import ErrorFactory from '../../models/ErrorFactory'

import { validationMixin } from 'vuelidate'
import {
  required,
  sameAs,
  minLength
} from 'vuelidate/lib/validators'

export default {
  name: 'PasswordEditForm',
  mixins: [validationMixin],
  components: {
    ErrorContainer
  },
  data: () => ({
    errorFactory: new ErrorFactory(),
    form: {
      oldPassword: null,
      password: null,
      repeatPassword: null
    },
    passwordUpdated: false,
    sending: false,
    error: null
  }),
  validations: {
    form: {
      oldPassword: {
        required
      },
      password: {
        required,
        minLength: minLength(8)
      },
      repeatPassword: {
        required,
        sameAs: sameAs('password')
      }
    }
  },
  computed: {
    token () {
      return this.$route.params.token
    },
    axios () {
      return this.$store.getters['axios']
    },
    base_url () {
      return this.$store.getters['base_url']
    }
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearForm () {
      this.$v.$reset()
      this.form.oldPassword = null
      this.form.password = null
      this.form.repeatPassword = null
    },
    async updatePassword () {
      this.sending = true
      this.error = null
      try {
        await this.axios.put(this.base_url + '/users/password/', {
          oldPassword: this.form.oldPassword,
          newPassword: this.form.password
        })
        this.passwordUpdated = true
      } catch (error) {
        this.error = this.errorFactory.make(error.response.data, 'Could not change password!')
      } finally {
        this.sending = false
      }
    },
    validate () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.updatePassword()
      }
    }
  }
}
</script>

<style lang="scss">
.password-edit-form {
  .md-progress-bar {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }
  .no-shadow  {
    box-shadow: none;
  }
  .md-title {
    text-align: left;
  }
  .md-error {
    color: red;
  }
  circle.md-progress-spinner-circle {
    stroke: rgba(0, 0, 0, 0.26) !important;
  }
  .forgot-password-container {
    margin-top: 16px;
    margin-left: 16px;
    color: rgba(0,0,0,0.5);
    width: 100%;
    text-align: left;
  }
  .error-container {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forms/PasswordEditForm.vue